//@ts-expect-error untyped
import CjkCharacterRegExp from 'I18n/constants/regex/CJK';
const MIN_SEARCH_QUERY_LEN_LATIN = 3;
const MIN_SEARCH_QUERY_LEN_LOGOGRAPHIC = 2;
export const getMinSearchQueryLen = query => {
  const containsCjkCharacter = CjkCharacterRegExp.test(query);
  return containsCjkCharacter ? MIN_SEARCH_QUERY_LEN_LOGOGRAPHIC : MIN_SEARCH_QUERY_LEN_LATIN;
};